import React from 'react';
import Header from './Global/Header';
import Footer from './Global/Footer';
import { Link} from "react-router-dom";

function ForgotPwd(){
    return(
        <>
        <Header />
        <div>
          
                

            <main className="main">
                <div className="container">
                    <div className="row row--grid">
                        <div className="col-12">
                            <ul className="breadcrumb">
                                <li className="breadcrumb__item"><Link to="/">Home</Link> <span> /</span></li>
                                <li className="breadcrumb__item breadcrumb__item--active">Forgot password</li>
                            </ul>
                        </div>
                        <div className="col-12">
                            <div className="sign">
                                <div className="sign__content">
                                    <form action="#" className="sign__form">
                                            <h3 style={{color:"#222227",marginBottom:"40px"}}>Forgot Password</h3>
                                        <div class="sign__group">
                                            <input type="text" class="sign__input" placeholder="Email" />
                                        </div>

                                        <div class="sign__group sign__group--checkbox">
                                            <input id="remember" name="remember" type="checkbox" defaultChecked="checked" />
                                            <label for="remember">I agree to the <a href="#">Privacy Policy</a></label>
                                        </div>
                                        
                                        <button class="sign__btn" type="button">Send</button>

                                        <span class="sign__text">We will send a password to your Email</span>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>



           
        </div>    

        <Footer />
        </>
    );
}

export default ForgotPwd;
